/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ErrorCode {
	InvalidAuthorization = "InvalidAuthorization",
	InvalidOrganization = "InvalidOrganization",
	InvalidRequest = "InvalidRequest",
	Unauthorized = "Unauthorized",
	MissingAppSettingConfig = "MissingAppSettingConfig",
	FieldIsRequired = "FieldIsRequired",
	ActivityDoneCantBeFuture = "ActivityDoneCantBeFuture",
	ImageManipulationFailed = "ImageManipulationFailed",
	NotFound = "NotFound",
	PersonCreateFailed = "PersonCreateFailed",
	ValidationError = "ValidationError",
	ArrayIsEmpty = "ArrayIsEmpty",
	ListBuildFailed = "ListBuildFailed",
	ListColumnDoesNotHaveFilterOptions = "ListColumnDoesNotHaveFilterOptions",
	ListInvalidStringId = "ListInvalidStringId",
	ListLoadDeserializationFailed = "ListLoadDeserializationFailed",
	CompanyIdMissing = "CompanyIdMissing",
	CompanyPersonSaveFailed = "CompanyPersonSaveFailed",
	AttachmentTooLarge = "AttachmentTooLarge",
	AttachmentInvalidType = "AttachmentInvalidType",
	AttachmentNotFound = "AttachmentNotFound",
	PasswordIncorrect = "PasswordIncorrect",
	PasswordCantBeSame = "PasswordCantBeSame",
	PasswordsMustMatch = "PasswordsMustMatch",
	UsernameExists = "UsernameExists",
	UserEmailExists = "UserEmailExists",
	EmailMissing = "EmailMissing",
	SurveyHasAnswers = "SurveyHasAnswers",
	SurveyNoAutoDeliveries = "SurveyNoAutoDeliveries",
	SurveyAutoDeliveryError = "SurveyAutoDeliveryError",
	InvalidTwoFACode = "InvalidTwoFACode",
	PersonHasActivities = "PersonHasActivities",
	PersonDeleteFailed = "PersonDeleteFailed",
	InvalidPassword = "InvalidPassword",
	NoRecipientsOnDelivery = "NoRecipientsOnDelivery",
	VentureDateMissing = "VentureDateMissing",
	EntityHasActivities = "EntityHasActivities",
	EntityHasServiceRequests = "EntityHasServiceRequests",
	EntityHasBusinessIdeas = "EntityHasBusinessIdeas",
	EntityHasDocuments = "EntityHasDocuments",
	EntityNotFound = "EntityNotFound",
	CompanyHasPersonnel = "CompanyHasPersonnel",
	ApplicationFormMustHaveStatuses = "ApplicationFormMustHaveStatuses",
	FieldMustHavePage = "FieldMustHavePage",
	ApplicationHasAnswers = "ApplicationHasAnswers",
	EmailInvalidDkim = "EmailInvalidDkim",
	EmailInvalidSpf = "EmailInvalidSpf",
	EmailIntegrationMailboxNotFound = "EmailIntegrationMailboxNotFound",
	Forbidden = "Forbidden",
	LastStartupperForBusinessIdea = "LastStartupperForBusinessIdea",
	Duplicate = "Duplicate",
	EmailSendFailure = "EmailSendFailure",
	EmploymentAreaAccessDenied = "EmploymentAreaAccessDenied",
	RequiresSuper = "RequiresSuper",
	EmploymentAreaInvalidUsers = "EmploymentAreaInvalidUsers",
	EmploymentAreaNotFound = "EmploymentAreaNotFound",
	RequiresAdmin = "RequiresAdmin",
	InvalidUser = "InvalidUser",
	EmploymentAreaOrganizationNotDeletable = "EmploymentAreaOrganizationNotDeletable",
	NoMunicipalitiesSelected = "NoMunicipalitiesSelected",
	ActivityLockedByOther = "ActivityLockedByOther",
	QuestionHasAnswers = "QuestionHasAnswers",
	ProjectHasAnswers = "ProjectHasAnswers",
	TriggerOrganizationHasProjects = "TriggerOrganizationHasProjects",
}
